import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectBriefComponent } from './project-brief/project-brief.component';
import { SubmissionGuidelinesInfoComponent } from './submission-guidelines-info/submission-guidelines-info.component';
import { SelectCompaniesComponent } from './select-companies/select-companies.component';
import { WorkPackagesComponent } from './work-packages/work-packages.component';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
@Component({
  imports: [
    CommonModule,
    ProjectBriefComponent,
    SubmissionGuidelinesInfoComponent,
    SelectCompaniesComponent,
    WorkPackagesComponent,
  ],
  standalone: true,
  selector: 'app-pqq-sections',
  templateUrl: './pqq-sections.component.html',
  styleUrls: ['./pqq-sections.component.css'],
})
export class PqqSectionsComponent implements OnInit {
  currentStep = 1;
  project_name: string;
  isEdit = false;
  nextStep() {
    if (this.currentStep < 4) {
      this.currentStep++;
    }
  }
  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.TenderingService.setEditState(true);
    }
  }
  @Output() closeModalEvent = new EventEmitter<boolean>();
  constructor(
    private ProjectsService: ProjectsService,
    private TenderingService: TenderingService
  ) {}

  ngOnInit(): void {
    this.project_name = localStorage.getItem('project-name');
    this.TenderingService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });
    if (this.isEdit) {
      this.submittedInitiationData();
    }
  }
  submittedInitiationData(): any {
    return this.ProjectsService.getSubmittedInitiationDataPQQ().subscribe({
      next: (response: any) => {
        this.calculateCurrentStep(response?.data);
      },
      error: (error) => {
        console.error('Error fetching record of Work Packages:', error);
      },
    });
  }

  calculateCurrentStep(data: any) {
    console.log('The api response is:', data);

    if (
      data.selected_work_packages.length === 0 &&
      !data.title &&
      !data.work_packages_des
    ) {
      this.currentStep = 2;
    } else if (data.selected_organizations.length === 0) {
      this.currentStep = 3;
    } else if (
      !data.reference_number &&
      !data.submission_deadline &&
      !data.issue_date &&
      !data.client
    ) {
      this.currentStep = 4;
    } else {
      this.currentStep = 1;
    }
  }

  handleCloseModal(closeModalValue: boolean) {
    if (closeModalValue) {
      this.closeModalEvent.emit(closeModalValue); // Emit closeModal value to the parent
    }
  }
}
